import Rubik from '../media/rubik';

export default function MobileSkills() {
    return (
        <section className="mobile-section mobile-skills-hybrid">
            <h2 className="mobile-section-title">Skills</h2>
            <div className="rubik-box">
                <Rubik onHint={true} />
            </div>
        </section>
    );
}
